import { Chip, Stack, Typography } from '@mui/material'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import List from '@mui/material/List'
import { styled } from '@mui/material/styles'
import { useEffect, useState } from 'react'
import Page from 'src/components/Page'
import PageHeader from 'src/components/page-header'
import FindProduct from 'src/views/product/FindProduct'

const ProductList = () => {
    const [reload, setReload] = useState(0)
    const [selected, setSelected] = useState([])
    const [skus, setSKUs] = useState()

    const ListItem = styled('li')(({ theme }) => ({
        float: 'left',
        listStyle: 'none',
        margin: theme.spacing(0.5),        
    }));

    useEffect(() => {
        // make 2D to 1D arrays
        setSKUs(Object.keys(selected).reduce((acc, key) => {
            return acc.concat(selected[key])
        }, []))
    }, [selected])
  
    const handleDelete = (sku) => {
        // filter out deselected item from map list
        const tmp = Object.keys(selected).reduce((acc, key) => {
            acc[key] = selected[key].filter(item => {
                return item !== sku;
            })

            return acc;
        }, {})

        setSelected(tmp)
    }

    const handleClick = () => {
        window.opener.productReceiver(skus.toString());
        self.close();
    }

    return (
        <Page title="Product">
            <Grid container spacing={6}>
                <PageHeader
                    title={
                        <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center">
                            <Typography variant='h5' color='#666CFF'>
                                상품검색
                            </Typography>
                            <Grid
                                justifyContent="flex-end"
                                alignItems="center">
                                    <Stack spacing={2} direction="row">
                                        <Button variant='contained' onClick={handleClick}> 적용 </Button>
                                        <Button variant='outlined' color='secondary' onClick={() => {self.close()}}> 취소 </Button>
                                    </Stack>                                
                            </Grid>
                        </Grid>
                    }
                    subtitle={
                        <>
                            <Typography variant='body2'>
                                선택된 상품 리스트를 보여줍니다.
                            </Typography>
                            <List>
                            {
                                skus?.map((sku, index) => {
                                    return (
                                        <ListItem key={index}>
                                            <Chip label={sku} variant="outlined" color="primary" onDelete={()=>handleDelete(sku)} />
                                        </ListItem>
                                    )
                                })
                            }
                            </List>
                        </>
                    }
                />                
                <Grid item xs={12}>                    
                    <FindProduct reload={reload} setReload={setReload} selected={selected} setSelected={setSelected} />
                </Grid>
            </Grid>
        </Page>
    )
}

export default ProductList